import { Component } from "react";
import { informarError } from "../../services/errores";
import "../../styles/Comun/Estados.css";

// ══════════════════════════════════════════════════════
//  Captura los errores al pintar una página (por ejemplo, cuando no se puede
//  descargar el trozo de una ruta lazy por falta de conexión o tras un despliegue nuevo)
//  y enseña un aviso con «Recargar» en vez de dejar la pantalla en blanco.
//  Patrón de EditorTexto.jsx de finanzas, aplicado a las rutas.
//  Se reinicia solo al cambiar de ruta (prop «reinicio» = pathname).
// ══════════════════════════════════════════════════════

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }

  static getDerivedStateFromError() {
    return { error: true };
  }

  // Además de enseñar el aviso, se informa a la API para poder arreglarlo (ver services/errores.js)
  componentDidCatch(error) {
    informarError("render", error);
  }

  componentDidUpdate(prev) {
    if (this.state.error && prev.reinicio !== this.props.reinicio) {
      this.setState({ error: false });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="estado-ruta" role="alert">
          <p>No se pudo cargar esta página. Comprueba tu conexión y recarga: lo que ya está guardado no se pierde.</p>
          <button type="button" className="boton" onClick={() => window.location.reload()}>
            Recargar la página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
